/* eslint-disable @typescript-eslint/no-explicit-any */
import requestAuth from 'utils/requestAuth';

const menuService = {
  getList: (params: any) => requestAuth.get(`/menu`, { params }),
  create: (data: any) => requestAuth.post('/menu', data),
  delete: (pid: any) => requestAuth.delete(`/menu/${pid}`),
  update: (pid: any, data: any) => requestAuth.put(`/menu/${pid}`, data)
};

export default menuService;
